module.exports = __webpack_public_path__ + "static/media/moduleSet_i0o3.539a1d21.jpg";